import { getUrlForLanguage } from '../utils/common';
import { redirectToUrl } from '../utils/url';
export default function loadSelectedLanguage(languageCode) {
  const newUrl = getUrlForLanguage(window.location.href, languageCode);
  redirectToUrl(newUrl);
}